import { Button } from "../ui/Button.jsx";

export function EffectsInfringer() {
  return (
    <section className="section effects effectsInfringer" id="effects-infringer">
      <div className="container">
        <div className="effectsGlass effectsGlass--infringer">
          <div className="sectionHead" data-reveal>
            <h2 className="h2">Личный кабинет нарушителя</h2>
            <p className="muted">
              Просматривайте претензии, выбирайте варианты урегулирования
              и следите за статусом дел в одном месте.
            </p>
          </div>

          <div className="grid2">
          <article className="card demo" data-reveal>
            <div className="demoTop">
              <h3 className="h3">Просмотр претензиях</h3>
            </div>
            <p className="muted">
              Все претензии отображаются в кабинете — ничего не теряется в почте.
            </p>
          </article>

          <article className="card demo" data-reveal>
            <div className="demoTop">
              <h3 className="h3">Досудебное урегулирование</h3>
            </div>
            <p className="muted">
              Возможность оперативно связаться с правообладателем и договориться о компенсации без суда.
            </p>
          </article>

          <article className="card demo" data-reveal>
            <div className="demoTop">
              <h3 className="h3">История и статусы дел</h3>
            </div>
            <p className="muted">
              Прозрачный статус по каждому делу: на рассмотрении, урегулирование, суд, исполнение.
            </p>
          </article>

          <article className="card demo" data-reveal>
            <div className="demoTop">
              <h3 className="h3">Документы и коммуникация</h3>
            </div>
            <p className="muted">
              Хранение переписки, претензий и соглашений в одном месте для вашей бухгалтерии и юристов.
            </p>
          </article>
          </div>

          <div className="effectsGlassCta" data-reveal>
            <Button as="a" href="/violater" variant="primary">
              Перейти в личный кабинет
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
